module.exports = __webpack_public_path__ + "img/black.1ee8ebe6.png";